import { render } from "./LocaleSwitcher.vue?vue&type=template&id=a4708636&scoped=true&ts=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=a4708636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4708636"]])

export default __exports__